module.exports = __webpack_public_path__ + "img/logo-update.35b51ea8.png";